<template>
    <div>
    <!-- Only appear once you've completed the payment section -->
      <p class="h4">Charitable Donation</p>
      <div class="row">
        <div class="col-md-4">
          <p>Orbital Fasteners supports Prostate Cancer research. <br><small>You can add a donation here. All donations are exc. VAT</small></p>
        </div>
        <template v-if="!donated">
          <div class="col-md-4">
            <div class="input-group">
              <span class="input-group-addon"><i class="fa fa-gbp" aria-hidden="true"></i></span>
              <input type="number" class="form-control" min="0" v-model="amount">
              <span class="input-group-addon btn btn-sm btn-blue" @click="save">
                Add Donation
              </span>
            </div>
          </div>
          <div class="col-md-3">
            <small>Perhaps consider rounding your order to the nearest &pound;1 ? <a href="#" @click.prevent="applyRounding">Click here</a></small>
              <!-- <button class="btn btn-sm btn-green" @click="applyRounding">Round order to nearest &pound;{{ rounded|number_format }} Exc. VAT</button> -->
          </div>
        </template>
        <template v-else>
          <div class="col-md-8">
            <strong class="text-success">Thank you!</strong><br>
            A donation of &pound;{{ donated.line_total|number_format(true) }} has been applied to your order. <a href="#" @click.prevent="remove">Remove Donation</a>
          </div>
        </template>
      </div>

    </div>
</template>

<script>
  import Order from '../../Services/Order.js';

  export default {
    data() {
      return {
        orders: Order,
        amount: 0
      }
    },
    computed: {
      pence() {
        return this.amount * 100;
      },
      donated() {
        return _.find(this.orders.order.lines, line => {
          return line.description == 'Charity Donation';
        });
      },
      rounded() {
        return Math.ceil(this.orders.order.sub_total / 100);
      }
    },
    methods: {
      save() {
        if (!this.amount) {
          return;
        }
        this.orders.addLine('charity-donation', 'Charity Donation', this.pence, 1, 0).then(response => {
          this.amount = 0;
        });
      },
      remove() {
        this.orders.removeLine(this.donated.id);
      },
      applyRounding() {
        this.amount = (this.rounded * 100 - this.orders.order.sub_total) / 100;
        this.save();
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Checkout/CharityDonation.vue